import { c as _c } from "react/compiler-runtime";
import { TooltipPropertiesType } from "@website/ui/tooltip/tooltip.types";
import { FocusEvent, MouseEvent, useEffect, useId, useRef, useState } from "react";
export function useTooltip(t0) {
  const $ = _c(17);
  const {
    id
  } = t0;
  const generatedId = useId();
  const [isOpen, setIsOpen] = useState(false);
  const [direction, setDirection] = useState("ltr");
  const triggerReference = useRef(null);
  const closeTimeout = useRef(undefined);
  const tooltipId = id || generatedId;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function cancelClose() {
      clearTimeout(closeTimeout.current);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const cancelClose = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function show(event) {
      cancelClose();
      setDirection(getComputedStyle(event.currentTarget).direction === "rtl" ? "rtl" : "ltr");
      setIsOpen(true);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const show = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function hide() {
      cancelClose();
      closeTimeout.current = setTimeout(() => {
        if (!triggerReference.current?.contains(document.activeElement)) {
          setIsOpen(false);
        }
      }, 100);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const hide = t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => clearTimeout(closeTimeout.current);
    t5 = [];
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[5] !== isOpen) {
    t6 = () => {
      if (!isOpen) {
        return;
      }
      const dismiss = function dismiss(event_0) {
        if (event_0.key === "Escape") {
          clearTimeout(closeTimeout.current);
          setIsOpen(false);
          event_0.stopPropagation();
        }
      };
      document.addEventListener("keydown", dismiss);
      return () => document.removeEventListener("keydown", dismiss);
    };
    t7 = [isOpen];
    $[5] = isOpen;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  useEffect(t6, t7);
  const t8 = isOpen ? tooltipId : undefined;
  let t9;
  if ($[8] !== t8) {
    t9 = {
      ref: triggerReference,
      "aria-describedby": t8,
      onMouseEnter: show,
      onMouseLeave: hide,
      onFocus: show,
      onBlur: hide
    };
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== tooltipId) {
    t10 = {
      id: tooltipId,
      role: "tooltip"
    };
    $[10] = tooltipId;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== direction || $[13] !== isOpen || $[14] !== t10 || $[15] !== t9) {
    t11 = {
      isOpen,
      direction,
      cancelClose,
      hide,
      tooltipProperties: t9,
      titleProperties: t10
    };
    $[12] = direction;
    $[13] = isOpen;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}